import barba_initialisation from './barba/animations_barbajs'

const init_app = () => barba_initialisation();

init_app();